import { useState, useEffect } from "react";

export default function useScreenWidth() {
  const [windowWidth, setWindowWidth] = useState<number | null>(null);

  const isWindow = typeof window !== "undefined";

  const resize = () =>
    setWindowWidth(isWindow ? window.innerWidth : windowWidth);

  useEffect(() => {
    if (isWindow) {
      setWindowWidth(isWindow ? window.innerWidth : windowWidth);

      window.addEventListener("resize", resize);

      return () => window.removeEventListener("resize", resize);
    }
    //eslint-disable-next-line
  }, [isWindow]);

  return windowWidth;
}
